"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const big_integer_1 = __importDefault(require("big-integer"));
const ALPHABETIC_CHARACTER_REGEXP = /[A-Z]/g;
const iso7064_Mod_97_10 = (ics) => {
    const step1 = `${ics.substring(7)}${ics.substr(0, 4)}`;
    const bigIntAsString = step1.replace(ALPHABETIC_CHARACTER_REGEXP, (character) => (character.charCodeAt(0) - 55).toString());
    return big_integer_1.default(bigIntAsString).mod(97).equals(1); // BigInt(step2) % 97n === 1n
};
exports.default = iso7064_Mod_97_10;
